export const SITE_HOSTNAME = "www.montenegrosecrets.com";
export const SITE_URL = `https://${SITE_HOSTNAME}`;
export const CONTACT_EMAIL = "info@montenegrosecrets.com";
